import { useState, useEffect, useRef } from "react";
import sal from "sal.js";
import api from "../../services/api";

import Banner from "./partials/Banner";
import "./InternationalPatientPage.css";
import ButtonsSection from "../home/partials/ButtonsSection";
import About from "./partials/About";
import MedicalDepartments from "./partials/MedicalDepartments";
import WhyChooseUs from "./partials/WhyChooseUs";
import MedicalJourney from "./partials/MedicalJourney";
import Departure from "./partials/Departure";
import TestimonialSection from "../home/partials/TestimonialSection";
import FaqSection from "../home/partials/FaqSection";
import MapSection from "../home/partials/MapSection";

const InternationalPatientPage = () => {
  const [faq, SetFaq] = useState([]);
  const [testimonials, SetTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const intFormRef = useRef(null);

  useEffect(() => {
    const fetchFaqs = async () => {
      setLoading(true);
      setError(null);
      try {
        const [faqsRes, testimonialsRes] = await Promise.all([
          api.get("/api/faqs/screen/international"),
          api.get("/api/testimonials/screen/international"),
        ]);
        SetFaq(faqsRes.data);
        SetTestimonials(testimonialsRes.data);
        setTimeout(() => sal({ threshold: 0.2, once: true }), 300);
      } catch (err) {
        console.error("Error fetching Faq Data:", err);
        setError("Failed to load home content. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchFaqs();
  }, []);

  if (loading || error) return null;

  return (
    <div className="international_patient_page">
      <Banner />
      <ButtonsSection scrollToForm={() => {
        intFormRef.current?.scrollIntoView({ behavior: "smooth" });
      }} />
      <About scrollToForm={() => {
        intFormRef.current?.scrollIntoView({ behavior: "smooth" });
      }} />
      <MedicalDepartments formRef={intFormRef} />
      <WhyChooseUs />
      <MedicalJourney />
      <Departure />
      {testimonials?.items?.length > 0 && <TestimonialSection testimonials={testimonials} />}
      {faq.length > 0 && <FaqSection faqs={faq} />}
      <MapSection />
    </div>
  );
};

export default InternationalPatientPage;
